/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { MultiIoDetails } from "./MultiIoDetails.ts";
import type { TokenTransactionMetadata } from "./TokenTransactionMetadata.ts";
import type { TransactionCounterparty } from "./TransactionCounterparty.ts";

export const addressTransactionTypeEnum = {
	spark_transfer: "spark_transfer",
	lightning_payment: "lightning_payment",
	bitcoin_deposit: "bitcoin_deposit",
	bitcoin_withdrawal: "bitcoin_withdrawal",
	token_transfer: "token_transfer",
	token_mint: "token_mint",
	token_burn: "token_burn",
	token_multi_transfer: "token_multi_transfer",
	unknown_token_op: "unknown_token_op",
} as const;

export type AddressTransactionTypeEnum =
	(typeof addressTransactionTypeEnum)[keyof typeof addressTransactionTypeEnum];

export const addressTransactionDirectionEnum = {
	incoming: "incoming",
	outgoing: "outgoing",
	creation: "creation",
	destruction: "destruction",
	transfer: "transfer",
	deposit: "deposit",
	withdrawal: "withdrawal",
	payment: "payment",
	settlement: "settlement",
	unknown: "unknown",
} as const;

export type AddressTransactionDirectionEnum =
	(typeof addressTransactionDirectionEnum)[keyof typeof addressTransactionDirectionEnum];

export const addressTransactionStatusEnum = {
	confirmed: "confirmed",
	pending: "pending",
	failed: "failed",
	expired: "expired",
} as const;

export type AddressTransactionStatusEnum =
	(typeof addressTransactionStatusEnum)[keyof typeof addressTransactionStatusEnum];

export type AddressTransaction = {
	/**
	 * @type string
	 */
	id: string;
	/**
	 * @type string
	 */
	type: AddressTransactionTypeEnum;
	/**
	 * @type string
	 */
	direction: AddressTransactionDirectionEnum;
	/**
	 * @type object
	 */
	counterparty: TransactionCounterparty;
	/**
	 * @type integer
	 */
	amountSats?: number | null;
	/**
	 * @type integer
	 */
	tokenAmount?: number | null;
	/**
	 * @type number, float
	 */
	valueUsd: number;
	/**
	 * @description When the transaction was first recorded/broadcast.
	 * @type string, date-time
	 */
	createdAt?: string | null;
	/**
	 * @description Last update / completion timestamp.
	 * @type string, date-time
	 */
	updatedAt?: string | null;
	/**
	 * @type string
	 */
	status: AddressTransactionStatusEnum;
	/**
	 * @type string
	 */
	txid?: string | null;
	/**
	 * @type object
	 */
	tokenMetadata?: TokenTransactionMetadata | null;
	/**
	 * @description Details for multi-input/output transactions
	 * @type object
	 */
	multiIoDetails?: MultiIoDetails | null;
};
